import { mediaItems } from '@/mocks/homeData';

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-[1200px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-3">
            精彩视听
          </span>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-950">
            热门视频精选
          </h2>
          <p className="mt-2 text-sm md:text-base text-foreground-600">
            图文并茂不够过瘾？来看看这些精彩的生活类视频内容
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {mediaItems.slice(0, 3).map((item, index) => (
            <div
              key={index}
              className="bg-background-100 rounded-xl overflow-hidden group cursor-pointer"
            >
              <div className="relative aspect-video overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-black/20 group-hover:bg-black/30 transition-colors duration-200 flex items-center justify-center">
                  <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-full bg-background-50/90 text-primary-500 group-hover:bg-primary-500 group-hover:text-background-50 transition-all duration-200">
                    <i className="ri-play-fill text-xl md:text-2xl ml-0.5"></i>
                  </div>
                </div>
                <div className="absolute bottom-2 right-2 px-2 py-1 rounded-md bg-black/60 text-background-50 text-xs font-medium">
                  {item.duration}
                </div>
              </div>
              <div className="p-4 md:p-5">
                <div className="flex items-center gap-3 mb-2 flex-wrap">
                  <span className="px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium whitespace-nowrap">
                    {item.tag}
                  </span>
                  <span className="text-xs text-foreground-500 flex items-center gap-1 whitespace-nowrap">
                    <i className="ri-eye-line"></i>{item.views}
                  </span>
                </div>
                <h3 className="text-sm md:text-base font-heading font-semibold text-foreground-900 line-clamp-2 group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
              </div>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 md:gap-6 mt-5 md:mt-6">
          {mediaItems.slice(3, 5).map((item, index) => (
            <div
              key={index + 3}
              className="bg-background-100 rounded-xl overflow-hidden group cursor-pointer flex flex-col sm:flex-row"
            >
              <div className="relative sm:w-2/5 aspect-video sm:aspect-auto overflow-hidden flex-shrink-0">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-black/20 group-hover:bg-black/30 transition-colors duration-200 flex items-center justify-center">
                  <div className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center rounded-full bg-background-50/90 text-primary-500 group-hover:bg-primary-500 group-hover:text-background-50 transition-all duration-200">
                    <i className="ri-play-fill text-lg md:text-xl ml-0.5"></i>
                  </div>
                </div>
                <div className="absolute bottom-2 right-2 px-2 py-1 rounded-md bg-black/60 text-background-50 text-xs font-medium">
                  {item.duration}
                </div>
              </div>
              <div className="p-4 md:p-5 flex flex-col justify-center">
                <div className="flex items-center gap-3 mb-2 flex-wrap">
                  <span className="px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium whitespace-nowrap">
                    {item.tag}
                  </span>
                  <span className="text-xs text-foreground-500 flex items-center gap-1 whitespace-nowrap">
                    <i className="ri-eye-line"></i>{item.views}
                  </span>
                </div>
                <h3 className="text-sm md:text-base font-heading font-semibold text-foreground-900 line-clamp-2 group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-8 md:mt-10">
          <a
            href="#contact"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-lg border border-background-300/60 text-foreground-600 text-sm font-medium hover:bg-background-100 transition-colors duration-200 cursor-pointer"
          >
            <i className="ri-video-line"></i>
            更多精彩视频持续更新中
          </a>
        </div>
      </div>
    </section>
  );
}